import React from 'react';

import { Numeric } from '@swyftx/aviary/atoms/Typography';
import { MarginInstrument } from '@swyftx/margin/build/types';
import { calculateMarginRequirements } from '@swyftx/margin/build/utils';

import { Big } from '@shared/safe-big';
import { formatCurrency } from '@shared/utils';

import { useMarginAccount } from 'src/lib/margin/hooks/account';
import { useMarginPrices } from 'src/lib/margin/hooks/prices';

type Props = {
  lots: string;
  price: Big;
  market?: MarginInstrument;
};

const EstimatedMarginRequired: React.FC<Props> = ({ lots, price, market }) => {
  const { currency } = useMarginAccount();
  const { getCurrencyRate } = useMarginPrices();

  return (
    <Numeric>
      {formatCurrency(
        calculateMarginRequirements({
          lots: Number(lots),
          orderPrice: price.times(getCurrencyRate()).toString(),
          contractSize: market?.contractSize,
          leverage: market?.maxLeverage,
        }),
        currency,
        { appendCode: true, hideCode: false },
      )}
    </Numeric>
  );
};

export { EstimatedMarginRequired };
